import addKey from "./addKey";

const defaultOptions = {
    variant: "info",
    message: "",
    params: {},
};

export default options =>
    addKey({
        ...defaultOptions,
        ...options,
    });
